import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableClientDetail = Loadable({
  loader: function loader() {
    return import('../Clients/ClientDetail.jsx');
  },
  loading: ComponentLoading
});
export default LoadableClientDetail;